module.exports = __webpack_public_path__ + "static/media/two.181afee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/onBoarding/two.png
// module id = 1582
// module chunks = 0